import React from "react";
import { Typography } from "@mui/material";

// Utility function to get name from userId
const getNameFromUserId = (userId: string, mentions: any[]) => {
  const name = mentions?.find((mention) => mention?.userId === userId)?.name;
  return name || `@${userId}`;
};

// Reusable component
interface FormatMentionTextProps {
  text: string;
  mentions: { userId: string; name: string }[];
  fontSize?: number | string;
}

const FormatMentionText: React.FC<FormatMentionTextProps> = ({
  text,
  mentions,
  fontSize = 14,
}) => {
  const parts = text?.split(/(##.*?##)/);

  return (
    <>
      {parts?.map((part, index) => {
        if (part?.startsWith("##") && part?.endsWith("##")) {
          const userId = part.slice(2, -2);
          const name = getNameFromUserId(userId, mentions);
          return (
            <Typography
              key={index}
              component="span"
              fontWeight={700}
              sx={{ wordWrap: "break-word", ml: 0.5, fontSize }}
            >
              @{name}
            </Typography>
          );
        }

        return (
          <Typography
            key={index}
            component="span"
            fontWeight={400}
            sx={{ wordWrap: "break-word", ml: 0.5, fontSize }}
          >
            {part}
          </Typography>
        );
      })}
    </>
  );
};

export default FormatMentionText;
